import * as React from 'react';

import { getDisplayName } from 'components/hoc';
import { delayed } from 'lib/Job';

import { WithTrackerPropsType } from 'components/hoc/Cards/withTracker';
import { WithUiStatePropsType } from 'components/hoc/Cards/withUiState';
import { CardProps } from 'components/molecules/Card';
import { CardTypeTypes } from 'types/Card';

export type HandleCompleteType = {
	type?: CardTypeTypes;
	onAnimationDone: () => void;
};

export type WithHandleCompleteProxyPropsType = CardProps & WithUiStatePropsType & WithTrackerPropsType;

export type WithHandleCompletePropsType = {
	onComplete: (type: HandleCompleteType) => void;
	isUiCompleting: boolean;
};

export type WithHandleCompleteStateType = {
	isUiCompleting: boolean;
};

export default function withHandleComplete<P extends object>(WrappedComponent: React.ComponentType<P>) {
	return class HandleCompleteProxy extends React.Component<
		P & WithHandleCompleteProxyPropsType,
		WithHandleCompleteStateType
	> {
		public static displayName = `withHandleComplete(${getDisplayName(WrappedComponent)})`;
		public state: WithHandleCompleteStateType = {
			isUiCompleting: false,
		};

		public removeFocus() {
			if (document && document.activeElement !== null) {
				(document.activeElement as HTMLElement).blur();
			}
		}

		public handleComplete = ({ type, onAnimationDone }: HandleCompleteType) => {
			this.removeFocus();
			this.setState({ isUiCompleting: true }, () => {
				this.props.onCompleteCard(() => {
					delayed(() => {
						this.props.onSetCardUIFolded();

						delayed(() => {
							onAnimationDone();
							this.setState({ isUiCompleting: false });
						}, 400);
					}, 600);
				});
			});

			if (typeof type === 'string') {
				this.props.trackCardCompleteAction(type);
			}
		};

		public render() {
			return (
				<WrappedComponent
					onComplete={this.handleComplete}
					isUiCompleting={this.state.isUiCompleting}
					{...this.props}
				/>
			);
		}
	};
}
